




import React, { useEffect, useRef, useState } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    IconButton,
    Button,
    Box,
    Typography,
    Grid,
    Divider,
} from "@mui/material";
import { CancelSharp, Close as CloseIcon } from "@mui/icons-material";
import { Formik, Form } from "formik";

import { FaPlus } from "react-icons/fa6";
import { MdPayment } from "react-icons/md";

import './EditProfileModal.css'; // Import external CSS
// import "../../../../Components/ModalCss/BannerinputGetModal.css";

import { MdCancel } from "react-icons/md";
import * as Yup from "yup";
import CustomInputLogin from "../../../Components/CustomInputLogin/CustomInputLogin";
import CustoDropDownRegister from "../../../Components/CustomDropDown/CustoDropDownRegister";
import CustomDateInput from "../../../Components/CustomDate/CustomDateInput";
import { useDispatch, useSelector } from "react-redux";
import actions from "../../../ReduxStore/actions";
import CustomEmailVerifyInput from "../../../Components/CustomEmailVerifyInput/CustomEmailVerifyInput";
// import EmailChangeFlow from "../../../Comp/onents/CustomEmailVerifyInput/CustomNewEmailChange";
import CustomNewEmailChange from "../../../Components/CustomEmailVerifyInput/CustomNewEmailChange";
import CustomNewMobileNumberChange from "../../../Components/CustomMobileNumber/CustomNewMobileNumberChange";
import CustImageUploadInput from "../../../Components/ProfileUpload/ProfileUpload";
import { toast, ToastContainer } from "react-toastify";

const validationSchema = Yup.object().shape({
    first_name: Yup.string().required("First name is required"),
    last_name: Yup.string().required("Last name is required"),
    date_of_birth: Yup.date().required("Date of birth is required"),
    gender: Yup.string().required("Gender is required"),
    personal_email_address: Yup.string()
        .email("Invalid email format")
        .required("Personal email is required"),
    official_email_address: Yup.string()
        .email("Invalid email format")
        .required("Official email is required"),
    phone_number: Yup.string()
        .matches(/^\d{10}$/, "Phone number must be 10 digits")
        .required("Phone number is required"),
    present_city: Yup.string().required("Present city is required"),
    Present_address: Yup.string().required("Present address is required"),
    year_of_completion: Yup.number()
        .min(1900, "Year must be valid")
        .max(new Date().getFullYear(), "Year cannot be in the future")
        .required("Year of completion is required"),
    batch: Yup.string().required("Batch is required"),
    campus: Yup.string().required("Campus is required"),
    course: Yup.string().required("Course is required"),
    website: Yup.string().url("Enter a valid URL").nullable(),

});

const EditProfileModal = ({
    open,
    onClose,
    setSubmittedValues,
    submittedValues,
}) => {
    const [uploadedFile, setUploadedFile] = useState(null);
    // const { createProject } = useSelector(state => state?.createProject);
    const { getUserById } = useSelector(state => state?.getUserById);
    console.log(getUserById, "getUserByIdgetUserById")

    const formikRef = useRef();
    const sessionUserId = sessionStorage.getItem("userId")
    const dispatch = useDispatch()
    const [viewImgApi, setViewImgApi] = useState(null);

    useEffect(() => {
        // profileImage
        setViewImgApi(getUserById?.data?.profileImage)

    }, [getUserById])

    console.log(viewImgApi, "viewImgApiviewImgApiviewImgApi")


    // useEffect(() => {

    //     if (!formikRef.current || !getUserById?.data) return;
    //     console.log("hiiiiii")

    //     const fetchData = async () => {
    //         const data1 = {
    //             data: {},
    //             method: "get",
    //             apiName: `getUserById/${sessionUserId}`,
    //         };
    //         const response = await dispatch(actions.GETUSERBYID(data1));

    //         //     console.log(response, "responseresponse")
    //         // const { setFieldValue } = formikRef.current;
    //         const formik = formikRef.current;
    //         const { setFieldValue } = formik;


    //         // if (response?.payload?.message === "Event fetched successfully.") {
    //         //     console.log("hiiii")

    //         // console.log(response, "responseresponse")
    //         // first_name: "",
    //         //     last_name: "",
    //         //         date_of_birth: "",
    //         //             gender: "",
    //         //                 personal_email_address: "",
    //         //                     official_email_address: "",
    //         //                         phone_number: "",
    //         //                             present_city: "",
    //         //                                 Present_address: "",
    //         //                                     year_of_completion: "",
    //         //                                         batch: "",
    //         //                                             campus: "",
    //         //                                                 course: "",
    //         //                                                     website: "",
    //         //                                                         password: "",
    //         //                                                             confirm_password: "",
    //         //                         }}

    //         setFieldValue("first_name", response?.payload?.data?.first_name)
    //         // setFieldValue("last_name", getUserById?.data?.event_title)
    //         // setFieldValue("date_of_birth", getUserById?.data?.requirements)
    //         // setFieldValue("gender", getUserById?.data?.from_date)
    //         // setFieldValue("personal_email_address", getUserById?.data?.to_date)
    //         // setFieldValue("personal_email_address", getUserById?.data?.to_date)
    //         // setFieldValue("personal_email_address", getUserById?.data?.to_date)
    //         // setFieldValue("personal_email_address", getUserById?.data?.to_date)
    //         // setFieldValue("personal_email_address", getUserById?.data?.to_date)
    //         // setFieldValue("personal_email_address", getUserById?.data?.to_date)
    //         // setFieldValue("personal_email_address", getUserById?.data?.to_date)
    //         // setFieldValue("personal_email_address", getUserById?.data?.to_date)
    //         // setFieldValue("personal_email_address", getUserById?.data?.to_date)




    //         const uploadedFiles = getUserById?.data?.attach_files
    //         console.log(uploadedFiles, "uploadedFileuploadedFile")


    //         // for (let i = 1; i <= 7; i++) {
    //         //     const imageKey = `image${i}`;
    //         //     const imgUrlKey = `img_url${i}`;

    //         //     if (data?.[imageKey] && data?.[imgUrlKey]) {
    //         //         uploadedFiles.push({
    //         //             id: i,
    //         //             fileUrl: data[imgUrlKey],
    //         //             type: "img",
    //         //             progress: 100,
    //         //         });
    //         //     }
    //         // }

    //         setUploadedFile(uploadedFiles);



    //     };
    //     fetchData();


    // }, []);


    const handleSubmit = async (values) => {
        const data1 = {
            data: {
                first_name: values?.first_name,
                last_name: values?.last_name,
                date_of_birth: values?.date_of_birth,
                gender: values?.gender,
                personal_email: values?.personal_email_address,
                official_email: values?.official_email_address,
                phone_no: values?.phone_number,
                present_city: values?.present_city,
                present_country: values?.present_country,
                present_state: values?.present_state,
                present_address: values?.Present_address,
                Year_of_completion: values?.year_of_completion,
                batch: values?.batch,
                campus: values?.campus,
                course: values?.course,
                website_url: values?.website,
                password: values?.password,
                // password_confirmation: values?.confirm_password
                profileImage: viewImgApi
            },
            method: "put",
            apiName: `editUserInfo/${sessionUserId}`,
        };
        const response = await dispatch(actions.EDITUSERINFO(data1));
        if (response?.payload?.message === "User information updated successfully.") {
            toast.success("User information updated successfully.")

            setTimeout(() => {
                onClose()

                // onClose()
                // onPreviewModalClose()

            }, 1500)

        }

    }



    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullWidth
            maxWidth="md"
            className="custom-dialog"
            sx={{
                // maxWidth: "600px",
                // margin: "auto",
                "& .MuiPaper-root": {
                    borderRadius: "14px", // Target the Paper component
                },
            }}
        >
            <Box sx={{ position: "relative" }}>
                <Box className="dialog-heading">
                    <IconButton
                        aria-label="Close"
                        onClick={onClose}
                        sx={{
                            position: "absolute",
                            top: 8,
                            right: 8,
                            color: 'white',
                        }}
                    >
                        <MdCancel />
                    </IconButton>
                    <DialogTitle className="custom-dialog-title">
                        <Box>
                            <Typography className="custom-title-text" sx={{color:"white"}}>Edit Profile</Typography>
                        </Box>
                    </DialogTitle>
                </Box>
                {/* <DialogContent> */}

                <DialogContent sx={{ overflowY: "scroll", height: "400px", p: 0 }}>

                    {/* <Box sx={{ position: "absolute", right: "10px", top: 5 }}>
                        <CancelSharp
                            style={{ display: { sx: "none", md: "block" } }}
                            // onClick={() => {
                            //     navigate("/")
                            // }}
                        />
                    </Box> */}
                    <Grid
                        item
                        size={{ md: 5, xs: 12 }}


                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            p: 2,
                            background: '#FFFFFF',
                            width: '100%',

                        }}
                    >

                        <Box sx={{
                            // display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
                            // boxShadow: { xs: 0, sm: 4, md: 4 },
                            padding: { xs: 0, sm: 3, md: 3 },
                            width: "100%",
                            // boxShadow: 4,
                            // m: 4


                            // border: "1px solid red"
                        }}>


                            <Formik
                                // innerRef={formikRef}
                                enableReinitialize
                                initialValues={{
                                    first_name: getUserById?.data?.first_name || "",
                                    last_name: getUserById?.data?.last_name || "",
                                    date_of_birth: getUserById?.data?.date_of_birth?.slice(0, 10) || "", // format YYYY-MM-DD
                                    gender: getUserById?.data?.gender || "",
                                    personal_email_address: getUserById?.data?.personal_email || "",
                                    official_email_address: getUserById?.data?.official_email || "",
                                    phone_number: getUserById?.data?.phone_no || "",
                                    present_city: getUserById?.data?.present_city || "",
                                    present_country: getUserById?.data?.present_country || "",
                                    present_state: getUserById?.data?.present_state || "",
                                    Present_address: getUserById?.data?.present_address || "",
                                    year_of_completion: getUserById?.data?.Year_of_completion || "",
                                    batch: getUserById?.data?.batch || "",
                                    campus: getUserById?.data?.campus || "",
                                    course: getUserById?.data?.course || "",
                                    website: getUserById?.data?.website_url || "",
                                    profileImage: getUserById?.data?.profileImage,

                                }}

                                validationSchema={validationSchema}
                                onSubmit={handleSubmit}
                            >
                                {({ handleSubmit, resetForm, formik, values, setFieldValue }) => (

                                    <Form onSubmit={handleSubmit}>
                                        < Grid container
                                            columnSpacing={4}
                                            rowSpacing={2}
                                        >
                                            <Grid size={{ xs: 12 }}>

                                                <CustImageUploadInput
                                                    label="Add cover image"
                                                    name="profileImage"
                                                    // isSubmitting={isSubmitting}
                                                    viewImgApi={viewImgApi}
                                                    setViewImgApi={setViewImgApi}
                                                // isFinalSubmit={activeStep === steps.length - 1}
                                                // isFormSubmitted={isFor}
                                                />
                                            </Grid>
                                            <Grid size={{ xs: 12, md: 4, sm: 6 }}>
                                                <CustomInputLogin
                                                    name="first_name"
                                                    label="First Name"
                                                    inputType="text"
                                                    custPlaceholder="Enter your first name"
                                                />
                                            </Grid>
                                            <Grid size={{ xs: 12, md: 4, sm: 6 }}>
                                                <CustomInputLogin
                                                    name="last_name"
                                                    label="Last Name"
                                                    inputType="text"
                                                    custPlaceholder="Enter your last name"
                                                />
                                            </Grid>

                                            <Grid size={{ xs: 12, md: 4, sm: 6 }}>
                                                <CustomDateInput
                                                    name="date_of_birth"
                                                    label="Date of Birth"
                                                    custPlaceholder="Enter your last name"

                                                />

                                            </Grid>
                                            <Grid size={{ xs: 12, md: 4, sm: 6 }}>
                                                <CustoDropDownRegister
                                                    name="gender"
                                                    label="Gender"
                                                    custPlaceholder="--Select--"
                                                    options={[
                                                        { label: "Male", value: "Male" },
                                                        { label: "Female", value: "Female" },
                                                        { label: "Third Gender", value: "ThirdGener" },
                                                    ]}
                                                />
                                            </Grid>
                                            <Grid size={{ xs: 12, md: 4, sm: 6 }}>
                                                <CustomNewEmailChange
                                                    label="Personal Email"
                                                    // formik={formik}
                                                    setFieldValue={setFieldValue}

                                                    value={values?.personal_email_address}
                                                    name="personal_email_address"
                                                />
                                            </Grid>


                                            <Grid size={{ xs: 12, md: 4, sm: 6 }}>
                                                <CustomInputLogin
                                                    name="official_email_address"
                                                    label="Official Email Address"
                                                    inputType="email"
                                                    custPlaceholder="Enter your Official Email Address"
                                                />
                                            </Grid>
                                            <Grid size={{ xs: 12, md: 4, sm: 6 }}>
                                                {/* <CustomInputLogin
                                                    name="phone_number"
                                                    label="Phone Number"
                                                    inputType="Number"
                                                    custPlaceholder="Enter your phone number"
                                                /> */}

                                                <CustomNewMobileNumberChange
                                                    label="Phone Number"
                                                    // formik={formik}
                                                    setFieldValue={setFieldValue}

                                                    value={values?.phone_number}
                                                    name="phone_number"
                                                />

                                            </Grid> <Grid size={{ xs: 12, md: 4, sm: 6 }}>
                                                <CustomInputLogin
                                                    name="present_city"
                                                    label="Present City"
                                                    inputType="text"
                                                    custPlaceholder="Enter your present city"
                                                />
                                            </Grid><Grid size={{ xs: 12, md: 4, sm: 6 }}>
                                                <CustomInputLogin
                                                    name="present_state"
                                                    label="Present State"
                                                    inputType="text"
                                                    custPlaceholder="Enter your present state"
                                                />
                                            </Grid>
                                            <Grid size={{ xs: 12, md: 4, sm: 6 }}>
                                                <CustomInputLogin
                                                    name="present_country"
                                                    label="Present Country"
                                                    inputType="text"
                                                    custPlaceholder="Enter your present country"
                                                />
                                            </Grid>
                                            <Grid size={{ xs: 12, md: 4, sm: 6 }}>
                                                <CustomInputLogin
                                                    name="Present_address"
                                                    label="Present Address"
                                                    inputType="text"
                                                    custPlaceholder="Enter your Personal Email Address"
                                                />
                                            </Grid>
                                            <Grid size={{ xs: 12, md: 4, sm: 6 }}>
                                                <CustomInputLogin
                                                    name="year_of_completion"
                                                    label="Year of Completion"
                                                    inputType="number"
                                                    custPlaceholder="Enter your year of completion"
                                                />
                                            </Grid>
                                            <Grid size={{ xs: 12, md: 4, sm: 6 }}>
                                                <CustomInputLogin
                                                    name="batch"
                                                    label="Batch"
                                                    inputType="text"
                                                    custPlaceholder="Enter your batch"
                                                />
                                            </Grid>
                                            <Grid size={{ xs: 12, md: 4, sm: 6 }}>
                                                <CustomInputLogin
                                                    name="campus"
                                                    label="Campus"
                                                    inputType="text"
                                                    custPlaceholder="Enter your campus"
                                                />
                                            </Grid>
                                            <Grid size={{ xs: 12, md: 4, sm: 6 }}>
                                                <CustomInputLogin
                                                    name="course"
                                                    label="Course"
                                                    inputType="text"
                                                    custPlaceholder="Enter your course"
                                                />
                                            </Grid>
                                            <Grid size={{ xs: 12, md: 4, sm: 6 }}>
                                                <CustomInputLogin
                                                    name="website"
                                                    label="Website(optional)"
                                                    inputType="text"
                                                    custPlaceholder="Enter your website"
                                                />
                                            </Grid>



                                            <Grid size={{ xs: 12 }} sx={{ display: "flex", justifyContent: "end" }}>
                                                <Button
                                                    variant="contained"
                                                    type="submit"
                                                    // onClick={handleGoRegisterComplete}
                                                    // sx={{ textTransform: "none", background: "#C38F51", color: "white", borderRadius: "23px" }}
                                                    sx={{
                                                        // backgroundColor: "#C38F51",
                                                        textTransform: "none",
                                                        color: "white",
                                                        fontSize: "16px",
                                                        mr: 2,
                                                        // padding: "0px 40px",
                                                        padding: { xs: "0px 20px", md: "0px 40px" },

                                                        minHeight: "40px",
                                                        boxShadow: "none",

                                                        // borderRadius: "23px",
                                                        background: "var(--main-color) 0% 0% no-repeat padding-box",
                                                        "&:hover": {
                                                            backgroundColor: "var(--main-color)",
                                                        },
                                                    }}
                                                >
                                                    Update
                                                </Button>
                                                <Button
                                                    variant="contained"
                                                    // type="submit"
                                                    onClick={() => {
                                                        resetForm()

                                                    }}
                                                    // sx={{ textTransform: "none", background: "#C38F51", color: "white", borderRadius: "23px" }}
                                                    sx={{
                                                        // backgroundColor: "#C38F51",
                                                        textTransform: "none",
                                                        color: "black",
                                                        fontSize: "16px",
                                                        // padding: "0px 40px",
                                                        padding: { xs: "0px 20px", md: "0px 40px" },

                                                        minHeight: "40px",
                                                        // boxShadow: 2,
                                                        // border:"1px solid gray",

                                                        // borderRadius: "23px",
                                                        background: "white 0% 0% no-repeat padding-box",
                                                        // "&:hover": {
                                                        //     backgroundColor: "#3B4056",
                                                        // },
                                                    }}
                                                >
                                                    Cancel
                                                </Button>
                                            </Grid>

                                        </Grid>
                                    </Form>
                                )}
                            </Formik>
                        </Box>
                    </Grid>
                </DialogContent>

            </Box>
            <ToastContainer
                position="top-right"
                autoClose={1500}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="dark"
            />
        </Dialog >
    );
};

export default EditProfileModal;
